import { data } from "jquery";
import {
  GET_UNLOCK_VALUE, SHOW_PLAYER, HIDE_PLAYER, SHOW_SIDEBAR, GET_SKILLS, GET_SKILL_DATA, RESET_LOADER, GET_SKILL_CUSTOM_PATH, GET_SKILL_PATH, GET_SKILL_POD, POD_RESOURCES_EMPTY, GET_RECOMMENDED_TOPICS, RESET_SKILLPATH, GET_POD_SUBTOPICS, GET_POD_RESOURCES, GET_TOPIC_RESOURCE, RESET_DATA,
  GET_NEXT_ADDITIONAL_CONTENT, RESET_ADDITIONAL, GET_ACTIVE_BTN, GET_SUGGESTED_POD, GET_ADDITIONAL_COUNT, GET_ADDITIONAL_CONTENT, GET_PREVIOUS_RESOURCE, ANALYTIC, GET_LIKE,
  RESET_RESOURCE_LOADING, RESET_LOADING, GET_RESOURCE_FROM_SUBTOPIC, TEST_AVAILABLITY, GET_LAST_ATTEMPT, GET_FEATURED_MENTOR, GET_COURSE, GET_COURSE_DETAILS, GET_ANSWER, GET_QUIZ_HISTORY
} from "../actionType/type";
import { getApiCall, postApiCall, putApiCall } from "../utils/request";
import { returnErrors } from "./errorAction";

export const backToList = () => async (dispatch) => {
  return dispatch({
    type: HIDE_PLAYER,
  });
};

export const showSidebar = () => async (dispatch) => {
  return dispatch({
    type: SHOW_SIDEBAR,
  });
};

export const resetLoader = () => async (dispatch) => {
  return dispatch({
    type: RESET_LOADER,
  });
};

export const getUnlockValue = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/data?skill_id=${id}`);
    dispatch({ type: GET_UNLOCK_VALUE, payload: response.data });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};


export const getSkills = (skilltype) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills?acquired=${skilltype}`);
    dispatch({ type: GET_SKILLS, payload: response.data.data });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const getSkillData = (skillId) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/details?skill_id=${skillId}`);
    dispatch({ type: GET_SKILL_DATA, payload: response.data });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};


export const getCustomSkillPaths = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/skillpath/custom?_id=${id}`);
    if (response.data.success) {
      dispatch({ type: GET_SKILL_CUSTOM_PATH, payload: response.data.data });
    }
  } catch (error) {
    returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
  }
};

export const getSkillPaths = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/skillpath?_id=${id}`);
    if (response.data.success) {
      dispatch({ type: GET_SKILL_PATH, payload: response.data.data });
      // if (response.data.data.length) {
      //     dispatch(getSkillPathPods(id, response.data.data[0]?._id))
      // }
    }
  } catch (error) {
    returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
  }
};

export const resetSkillPaths = () => async (dispatch) => {
  return dispatch({ type: RESET_SKILLPATH });
};

export const getCustomSkillPathPods = (sid, spId) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/skillpath/custom/pods?_id=${spId}`);
    const data1 = response.data.data;
    if (response.data.data.length) {
      dispatch({ type: GET_SKILL_POD, payload: { data1, sid, spId, type: 'custom' } });
    } else {
      dispatch({ type: POD_RESOURCES_EMPTY });
    }
  } catch (error) {
    returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
  }
};

export const getRecommended = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/test/report/latest?skill_id=${id}`);
    const data = response.data.data;
    if (response.data.data) {
      dispatch({ type: GET_RECOMMENDED_TOPICS, payload: data });
    }
  } catch (error) {
    returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
  }
};

export const getSkillPathPods = (sid, spId) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/skillpath/pods?skillpath_id=${spId}&skill_id=${sid}`);
    const data1 = response.data.data;
    if (response.data.data.length) {
      dispatch({ type: GET_SKILL_POD, payload: { data1, sid, spId, type: 'default' } });
    } else {
      dispatch({ type: POD_RESOURCES_EMPTY });
    }
  } catch (error) {
    returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
  }
};

export const getPodResources = (id, skillpod) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/pod?_id=${id}`);
    const data = response.data.data;
    dispatch({ type: GET_POD_RESOURCES, payload: { data, skillpod, id } });
  } catch (error) {
    returnErrors(
      dispatch,
      error.response?.data.message,
      error.response?.status
    );
  }
};

export const getPodSubtopics = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/pod/subtopics?_id=${id}`);
    const data = response.data.data;
    dispatch({ type: GET_POD_SUBTOPICS, payload: { data, id } });
  } catch (error) {
    returnErrors(
      dispatch,
      error.response?.data.message,
      error.response?.status
    );
  }
};

export const getTopicResource = (id, topic, index) => async (dispatch) => {
  return dispatch({
    type: GET_TOPIC_RESOURCE,
    payload: { id, topic, index },
  });
};

export const removeSkill = (id) => async (dispatch) => {
  let obj = {
    _id: id,
  };
  try {
    const response = await postApiCall(`user/learn/skills/deactivate`, obj);
    if (response.data.success) {
      getSkills("acquired");
      returnErrors(dispatch, 'Skill removed successfully', response?.status);
    }
    else {
      returnErrors(dispatch, response?.data.message, response?.status);
    }
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const resetData = () => async (dispatch) => {
  return dispatch({
    type: RESET_DATA,
  });
};

export const onBtnchange = (activeBtn, type) => async (dispatch) => {
  return dispatch({
    type: GET_ACTIVE_BTN,
    payload: { activeBtn, type },
  });
};

export const getSuggestedPod = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/suggestion?_id=${id}`);
    const data = response.data.data;
    dispatch({ type: GET_SUGGESTED_POD, payload: data });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const getAdditionalContentCount = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/additional?_id=${id}`);
    dispatch({ type: GET_ADDITIONAL_COUNT, payload: response.data.count });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const getAdditionalContents = (id, type, page) => async (dispatch) => {
  try {
    const response = await getApiCall(
      `user/learn/skills/additional/contents?_id=${id}&type=${type}&page=${page}`
    );
    const data = response.data.data;
    dispatch({ type: GET_ADDITIONAL_CONTENT, payload: { data, type } });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const resetAdditional = () => async (dispatch) => {
  return dispatch({
    type: RESET_ADDITIONAL,
  });
};
export const getNextAdditionalContents = (id, type, page) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/additional/contents?_id=${id}&type=${type}&page=${page}`);
    const data = response.data.data;
    dispatch({ type: GET_NEXT_ADDITIONAL_CONTENT, payload: { data, type } });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const getResourceData = (contentType, id, type) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/resource?type=${contentType}&_id=${id}`);
    const data = response.data;
    dispatch({ type: SHOW_PLAYER, payload: { data, type } });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const getPrevResource = (details, type) => async (dispatch) => {
  return dispatch({
    type: GET_PREVIOUS_RESOURCE,
    payload: { details, type },
  });
};


export const viewAnalytic = (analytic) => async (dispatch) => {
  try {
    const response = await postApiCall("user/learn/analytic", analytic);
    dispatch({ type: ANALYTIC, payload: analytic });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const onLikeClick = (data) => async (dispatch) => {
  let likedId = {
    r_id: data._id,
    type: data.type,
    liked: data.liked,
  };
  try {
    const response = await postApiCall("user/learn/resource/like", likedId);
    dispatch({ type: GET_LIKE, payload: likedId });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const resetResourceLoading = () => async (dispatch) => {
  return dispatch({
    type: RESET_RESOURCE_LOADING,
  });
};

export const resetLoading = () => async (dispatch) => {
  return dispatch({
    type: RESET_LOADING,
  });
};



export const getResourcesFromsubtopic = (title) => async (dispatch) => {
  return dispatch({
    type: GET_RESOURCE_FROM_SUBTOPIC,
    payload: title,
  });
};


export const getLastTestAttempt = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/test/last-attempt?skill_id=${id}`);
    const data = response.data.data;
    dispatch({ type: GET_LAST_ATTEMPT, payload: data });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const checkTestAvailable = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/skills/check-test/${id}`);
    const data = response.data;
    dispatch({ type: TEST_AVAILABLITY, payload: data });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const getFeaturedMentor = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/mentors/featured?page=1&skill_id=${id}`);
    const data = response.data.data;
    dispatch({ type: GET_FEATURED_MENTOR, payload: data });
  } catch (error) {
    returnErrors(dispatch, error.response?.data.message, error.response?.status);
  }
};

export const requestedContent = (id) => async (dispatch) => {
  let obj = {
    _id: id
  }
  try {
    const response = await postApiCall("user/learn/request", obj);
    if (response.data.success) {
      returnErrors(dispatch, 'Thank you for your request.Our team will get back to you', response?.status)
    }
  } catch (error) {
    returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
  }
};


export const getCourses = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/courses/list?skill_id=${id}`);
    dispatch({ type: GET_COURSE, payload: response.data });
  } catch (error) {
    returnErrors(
      dispatch, error.response?.data.message, error.response?.status
    );
  }
};

export const getCourseDetails = (id) => async (dispatch) => {
  try {
    const response = await getApiCall(`user/learn/course/${id}`);
    dispatch({ type: GET_COURSE_DETAILS, payload: response.data.data });
  } catch (error) {
    returnErrors(
      dispatch, error.response?.data.message, error.response?.status
    );
  }
};


export const imageUploaded = (obj) => async (dispatch) => {
  try {
    const response = await postApiCall(`user/learn/course/upload-certificate`, obj);
    if (response.data.success) {
      returnErrors(dispatch, 'Certificate uploaded successfully', response?.status)
    } else {
      returnErrors(dispatch, response?.data?.message, response?.status)
    }
  } catch (error) {
    returnErrors(
      dispatch, error.response?.data.message, error.response?.status
    );
  }
};

export const updatedStatus1 = (obj) => async (dispatch) => {
  try {
    const response = await postApiCall(`user/learn/courses/tracker/add-update`, obj);
    // dispatch({ type: STATUS_UPDATE, payload: response.data });
    if (response.data.success) {
      returnErrors(dispatch, 'Status updated successfully', response?.status)
    } else {
      returnErrors(dispatch, response?.data?.message, response?.status)
    }
  } catch (error) {
    returnErrors(
      dispatch, error.response?.data.message, error.response?.status
    );
  }
};

export const addCourse = (obj) => async (dispatch) => {
  try {
    const response = await postApiCall(`user/learn/skills/courses/add`, obj);
    if (response.data.success) {
      returnErrors(dispatch, 'Course added successfully', response?.status)
    } else {
      returnErrors(dispatch, response?.data?.message, response?.status)
    }
  } catch (error) {
    returnErrors(
      dispatch, error.response?.data.message, error.response?.status
    );
  }
};

export const editedCourse = (obj) => async (dispatch) => {
  try {
    const response = await putApiCall(`user/courses/update`, obj);
    if (response.data.success) {
      returnErrors(dispatch, 'Course updated successfully', response?.status)
    } else {
      returnErrors(dispatch, response?.data?.message, response?.status)
    }
  } catch (error) {
    returnErrors(
      dispatch, error.response?.data.message, error.response?.status
    );
  }
};

export const selectAnswer = (qid, aid) => async (dispatch) => {
  const answer = {
    q_id: qid,
    a_id: aid
  }
  try {
    const response = await postApiCall('user/learn/quiz/answer', answer);
    const data = response.data;
    return dispatch({ type: GET_ANSWER, payload: { data, aid, qid } });
  } catch (error) {
    returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
  }
}

export const quizSubmitted = (obj) => async (dispatch) => {

  try {
    const response = await postApiCall('user/learn/quiz/submit', obj);
    const data = response.data;
    console.log(data)
    // return dispatch({ type: GET_ANSWER, });
  } catch (error) {
    returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
  }
}

export const getQuizHistory = (id) => async (dispatch) => {

  try {
    const response = await getApiCall(`user/learn/quiz/history?quiz_id=${id}`);
    return dispatch({ type: GET_QUIZ_HISTORY, payload: response.data });
  } catch (error) {
    returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
  }
}

export const sendVideoError = (obj) => async (dispatch) => {

  try {
    await postApiCall(`send/analytic/data/email`, obj);
  } catch (error) {
    returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
  }
}